import { DevelopmentSuiteRequestError, type ProjectRecordKind } from "@/api/development_suite";

export const developmentSuiteKeys = {
  all: (municipalityId: number) => ["development_suite", municipalityId] as const,
  projects: (municipalityId: number, page: number) =>
    ["development_suite", municipalityId, "projects", page] as const,
  project: (municipalityId: number, projectId: number) =>
    ["development_suite", municipalityId, "project", projectId] as const,
  records: (municipalityId: number, projectId: number, kind: ProjectRecordKind, page: number) =>
    ["development_suite", municipalityId, "project", projectId, kind, page] as const,
  projectContacts: (municipalityId: number, projectId: number) =>
    ["development_suite", municipalityId, "project", projectId, "contacts"] as const,
  projectContactsPage: (municipalityId: number, projectId: number, page: number) =>
    ["development_suite", municipalityId, "project", projectId, "contacts", page] as const,
  contactDirectory: (municipalityId: number) => ["development_suite", municipalityId, "contacts"] as const,
  contactSearch: (municipalityId: number, query: string) =>
    ["development_suite", municipalityId, "contacts", query] as const,
};

/** Denied, missing, and invalid requests answer the same way on retry. */
export function retryDevelopmentSuiteRequest(failureCount: number, error: unknown): boolean {
  if (error instanceof DevelopmentSuiteRequestError && error.status >= 400 && error.status < 500) return false;
  return failureCount < 3;
}

export function isDeniedError(error: unknown): boolean {
  return error instanceof DevelopmentSuiteRequestError && error.status === 403;
}

export function isNotFoundError(error: unknown): boolean {
  return error instanceof DevelopmentSuiteRequestError && error.status === 404;
}

export function formatDateTime(iso: string): string {
  return new Intl.DateTimeFormat(undefined, { dateStyle: "medium", timeStyle: "short" }).format(new Date(iso));
}

/** Blank optional fields are sent as null so clearing a value clears it on the server. */
export function blankToNull(value: string): string | null {
  const trimmed = value.trim();
  return trimmed === "" ? null : trimmed;
}
